<template lang="pug">
div
    #map.fill-width(v-if="geometrias.length > 0" :style="customMapa")
    .empty(v-else) Não há vetorização para ser exibida.
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import mapConfig from '@/utils/map.utils';

export default {
    props: {
        geometrias: {
            type: Array,
            required: true,
        },
        customMapa: {
            type: String,
            required: false,
            default: 'height: 500px;'
        }
    },
    data() {
        return {
            mapConfig,
            map: null
        }
    },
    mounted() {
        if (this.geometrias.length > 0) {
            // iniciar mapa
            this.map = L.map('map');
            L.tileLayer(this.mapConfig.url, {
                attribution: this.mapConfig.attribution
            }).addTo(this.map);

            // adicionar geometrias
            let layer;
            for (const geo of this.geometrias) {
                layer = L.geoJSON(geo, {
                    color: geo?.color ?? '#03B1FC',
                    fillOpacity: geo?.fillOpacity ?? 0.4,
                }).addTo(this.map);
            }

            this.map.fitBounds(layer.getBounds());
        }
    }
}
</script>